import React from 'react';
import classes from './CustomModal.module.css';
import { Modal } from 'react-bootstrap';
import CloseButton from '../CloseButton/CloseButton';

const CustomModal = (props: any) => {
  const {
    size
  } = props;

  const dialogClasses = [classes.dialog];

  if (size === "sm") {
    dialogClasses.push(classes.sm);
  } else if (size === "lg") {
    dialogClasses.push(classes.lg);
  }

  return (
    <Modal
      centered
      show={props.show}
      onHide={props.onHide}
      dialogClassName={dialogClasses.join(" ")}
    >
      <Modal.Body>
        <CloseButton onClick={() => props.onHide()} />
        {props.children}
      </Modal.Body>
      {props.footer?
        <Modal.Footer>
          {props.footer}
        </Modal.Footer>
        :<></>}
    </Modal>
  );
};

export default React.memo(
  CustomModal,
  (prevProps, nextProps) =>
    nextProps.show === prevProps.show &&
    nextProps.children === prevProps.children
);
